export const defaultSamplingRate = 0;
